'use client'

import { useSession } from 'next-auth/react'
import { useVariantSelection } from '@/lib/commerce/hooks'
import { formatImageURL, formatPrice, getProductDisplayPrice } from '@/utils/util'
import { cn } from '@/lib/utils'
import VariantOptionPicker from './VariantOptionPicker'

// Quick-add body for option products: pick every option, then add explicitly —
// a flat list can't add on click once two choices are needed.
export default function VariantOptionQuickAdd({ product, tone = 'light', onAdd }: { product: any; tone?: 'light' | 'dark'; onAdd: (_variantId: string) => void }) {
  const { data: session } = useSession()
  const { selectedVariant, selectedOptions, selectOption, isSelectionPurchasable, isVariantAvailable } = useVariantSelection(product)
  const canAdd = isSelectionPurchasable && !!selectedVariant?.id && isVariantAvailable(selectedVariant)
  const price = selectedVariant ? getProductDisplayPrice(product, selectedVariant, !!session?.user?.id) : 0
  const image = formatImageURL(selectedVariant?.images?.[0] || 'placeholder.png')
  const dark = tone === 'dark'

  return (
    <div className="space-y-5">
      <div className="flex items-center gap-3">
        <img src={image} alt={product?.name} className="size-16 rounded-md object-cover" />
        <div className="min-w-0">
          <div className={cn('text-sm truncate', dark ? 'text-white/60' : 'text-muted-foreground')}>{isSelectionPurchasable ? selectedVariant?.name : 'Энэ хослол байхгүй'}</div>
          <div className={cn('text-base font-semibold', dark ? 'text-white' : 'text-foreground')}>{price === 0 ? 'Үнэгүй' : formatPrice(price)}</div>
        </div>
      </div>
      <VariantOptionPicker product={product} selected={selectedOptions} onSelect={selectOption} tone={tone} />
      <button
        type="button"
        disabled={!canAdd}
        onClick={() => { if (selectedVariant?.id) onAdd(selectedVariant.id) }}
        className={cn('w-full h-11 rounded-full text-sm font-semibold transition-opacity cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed', dark ? 'bg-white text-[#0a0a0c]' : 'bg-foreground text-white')}
      >
        {canAdd ? 'Сагсанд нэмэх' : 'Дууссан байна'}
      </button>
    </div>
  )
}
